import React, { Component } from "react";
import PropTypes from "prop-types";
import Dimensions from "react-dimensions";
import { YouTube } from "../../../../../editor/components";
class YoutubePreview extends Component {
  constructor(props) {
    super(props);
    this._onReady = this._onReady.bind(this);
  }
  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }
  render() {
    const { videoId } = this.props;
    const height = this.props.containerWidth / (16 / 9);

    const opts = {
      width: this.props.containerWidth,
      height: height
    };
    return (
      <YouTube
        videoId={videoId}
        opts={opts}
        id={videoId}
        onReady={this._onReady}
      />
    );
  }
}
YoutubePreview.propTypes = {
  videoId: PropTypes.string
};
export default Dimensions()(YoutubePreview);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/YoutubePreview.js